













































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import iwModal from "@/shared/components/Modal.vue";
import iwButtonLoading from "@/shared/components/ButtonLoading.vue";

import { deleteClassified } from "@/shared/scripts/ClassifiedsApi";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";

export default Vue.extend({
    components: {
        iwButtonLoading: iwButtonLoading,
        iwModal: iwModal,
    },

    data: function() {
        return {
            isCorrectlyDeleted: false,
            isLoading: false,
            specificId: uuidv4() as string,
            errorMessage: false,
        };
    },

    computed: {
        isDeleteModalOpen: function(): boolean {
            return this.$store.getters["ModalModule/isDeleteModalOpen"];
        },
        descriptionPhrases: function(): string[] {
            const text = this.$t("classified_delete_confirmation_text") as string;
            return text.split(/\\n/) as string[];
        },
    },

    methods: {
        closeDeleteModal: function(): void {
            this.isCorrectlyDeleted = false;
            this.$store.commit("ModalModule/closeDeleteModal");
        },

        openDeleteModal: function(): void {
            this.$store.commit("ModalModule/openDeleteModal");
        },

        deleteClassifiedCall: function(): void {
            this.isLoading = true;

            deleteClassified().then((responseStatus: boolean) => {
                this.isLoading = false;
                this.isCorrectlyDeleted = responseStatus;

                if (responseStatus) {
                    this.$emit("delete");
                }
            }).catch(error => {
                this.dialog.alert(i18n.t("server_not_responding_error").toString());
                this.isLoading = false;
                console.error(error);
            });
        }
    }
});

